import { useContext, useEffect, useState } from "react";
import ContentPage from "../../Content";
import axios from "axios";
import separateNumber from "../../../utils/separateur";
import moment from "moment";
import CustomerStyle from "../../../utils/customerStyle";
import BaseUrl from "../../../utils/BaseUrl";
import ExportExcel from "../../../utils/ExcelExport";
import { UserContext } from "../../../utils/User_check";
import { useNavigate } from "react-router-dom";
import can from "../../../utils/Can";


const url = BaseUrl();
const customerStyle = CustomerStyle();
function TransactionSoldeGesitePage(){

    const [itemsList,setItemsList] = useState([]);
    const [itemsListFilter,setItemsListFilter] = useState([]);
    const [loading, setLoading] = useState(false);
    const [newComponent,setNewComponent] = useState('list');
    const [item,setItem] = useState(null);
    const [dateTime,setDateTime] = useState(new Date()) ;
    const [dateDebut,setDateDebut] = useState('');
    const [dateFin,setDateFin] = useState('');

    const columns = [

      // {
      //   name: "SECTEUR",
      //   selector : row => row.SecteurCommercial
      // },
  
      {
        name: "SITE",
        selector : row => row.Site
      },
      {
          name: "PRINCIPAL",
          selector : row => row.EstPrincipal
        },
      {
        name: "FDR COMMERCIAUX",
        selector : row => <b className="text-dark">{separateNumber(row.FondDeRoulementCommerciaux)}</b>
      },
      {
        name: "FDR GESITES",
        selector : row => <b className="text-dark">{separateNumber(row.FondDeRoulementGesite)}</b>
      },

      {
          name: "FDR SITES",
          selector : row => <b className="text-success">{separateNumber(parseInt(row.FondDeRoulementCommerciaux) + parseInt(row.FondDeRoulementGesite) )}</b>
        },
  
      {
        name: "ACTION",
        selector : row => (
          <>
          <button className="btn btn-primary p-2" onClick={()=> chanhePageFunction(row)}>Voir plus</button>
         
          </>
        )
      },
  
  
  
  ];

  const {user,role, permissions} = useContext(UserContext);
  const navigate = useNavigate();
  useEffect(()=>{
    if(user && permissions && !can(permissions,'LISTE TRANSACTIONS GESITE')){
        navigate('/page-no-found');
    }
},[user]);

  useEffect(()=>{
      fetchItemsList(dateTime);
    },[]);
    const fetchItemsList = async (date_debut,date_fin)=>{
      setLoading(true);
      try {
          axios.post(url.base+'/transaction_gesite_solde',{date_debut:moment(date_debut).format('YYYY-MM-DD'),date_fin:moment(date_fin).format('YYYY-MM-DD')},
          {
              headers:{
                  'Content-Type':'application/json',
                  "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                  
              },
          }).then((resp)=>{
  
              if(resp.status == 200){
                  setItemsList(resp.data);
                  setItemsListFilter(resp.data);
              }
              setLoading(false);
          })
      } catch (error) {
          setLoading(false);
      }
  }
  
  const handleFilter=(event)=>{
    const datas = itemsListFilter?.filter(row => row.Site.toLowerCase().includes(event.target.value.toLowerCase() ) || row.SecteurCommercial.toLowerCase().includes(event.target.value.toLowerCase()) || row.Numero.toLowerCase().includes(event.target.value.toLowerCase()) || row.Produit.toLowerCase().includes(event.target.value.toLowerCase())  )  ;
    setItemsList(datas);
  }

  const conditionalRowStyles = [
      {
        when: row => row.EstPrincipal == "NON", // La condition pour colorer la ligne
        style: {
          backgroundColor: 'rgba(255, 0, 0, 0.1)',
          color: 'red',
          '&:hover': {
            cursor: 'pointer',
          },
        },
      },
  ];

  const chanhePageFunction=(row)=>{
      setNewComponent('detail');
     setItem(row);
      
  }

  const handleFilterDate=(event)=>{
    const dateValue = event.target.value;
    if(event.target.value !== ""){
        setDateTime(dateValue);
        setDateFin(dateValue)
        fetchItemsList(dateDebut,dateValue);
    }

    
  }
    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
            <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pr-3 fs-4">Page</p>
                  </a>
                  <a class="pl-3 mr-4" href="#">
                    <p class="m-0 fs-4">Liste des transactions Gesites</p>
                  </a>
                </div>
                
              </div>
              <div class="header-left">
                {/* <Link class="btn btn-primary mb-2 mb-md-0 mr-2" to="/parametres/add-commercial"> Ajouter un commercial</Link> */}
                {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
              </div>
              
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
            <div class="card-header">
                      <div class="row">
                          <div class=" col-lg-3 col-md-3">
                              <input type="search" class="form-control " placeholder="Recherche..." onChange={handleFilter}/>
                          </div>

                          <div class=" col-lg-3 col-md-3">
                              <input type="date" class="form-control"  onChange={(e)=>setDateDebut(e.target.value)}/>
                          </div>
                          <div class=" col-lg-3 col-md-3">
                              <input type="date" class="form-control"  onChange={handleFilterDate}/>
                          </div>

                          <div class=" col-lg-3 col-md-3">
                          <ExportExcel excelData={itemsListFilter} filename={"LISTES DES TRANSACTIONS-GESITES"}  title={"Télécharger Excel"} color={"btn-success"}/>
                        </div>
                  </div>
              </div>
                <h2 className="text-center">LISTE DES TRANSACTIONS DU   { dateFin =='' ? moment(dateTime).format('DD-MM-YYYY') : `${moment(dateDebut).format('DD-MM-YYYY')} AU ${moment(dateFin).format('DD-MM-YYYY')}`}</h2>

                {loading &&
                <div class="text-center">
                <div class="spinner-border" role="status">
                  {/* <span class="visually-hidden">Loading...</span> */}
                </div>
              </div>
                }

               
                  <div class="accordion p-3" id="accordionExample">
                  {!loading ?
                  
                  itemsList.map((row,index)  => (
                  <>

                 
                  {/* <div class="accordion-item p-3">
                    <h2 class="accordion-header" id={`headingOne${order+1}`}>
                      <button class="accordion-button fw-bold" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne${order+1}`} aria-expanded="true" aria-controls={`collapseOne${order+1}`}>
                      {order+1} - {sellerName}
                      </button>
                    </h2>
                    <div id={`collapseOne${order+1}`} class="accordion-collapse collapse" aria-labelledby={`headingOne${order+1}`} data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                      <p><strong>Total des appros : </strong><b className="text-success">{ separateNumber(sellerData.totalSales) } FCFA</b></p>
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <thead> 
                            <tr>
                              <th>ID</th>
                              <th>DATE</th>
                              <th>TERRITOIRE</th>
                              <th>SECTEUR</th>
                              <th  className="text-center">PRODUIT</th>
                              <th  className="text-center">MONTANT</th>
                              <th>N° MARCHAND POS</th>
                            </tr>
                          </thead>
                          <tbody>
                          {sellerData.sales.map((vente, index) => (
                            <tr key={index}>
                              <td class="py-1">
                                <img src="../../../assets/images/faces-clipart/pic-1.png" alt="image"/>
                              </td>
                              <td>{moment(vente.DateVente).format('Do MMMM YYYY')}</td>
                              <td>
                                {vente.NomTerritoire}
                              </td>
                              <td>
                                {vente.NomSecteur}
                              </td>
                              <td className="text-center">
                                {vente.NomProduit}
                              </td>
                              <td className="text-center">
                                  <b className={vente.Montant > 100000 ? "text-danger" : "text-success"}>{separateNumber(vente.Montant)  }</b>
                              </td>                            
                              <td>{vente.NumeroMarchandPOS}</td>
                            </tr>
                          ))}
                          </tbody>
                        </table>
                      </div>
                      </div>
                    </div>
                  </div> */}
               
               
                     <div class="card-body pb-3 border bg-dark" key={row.Id}>
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <thead> 
                            <tr className="bg-info">
                              <th>SECTEUR</th>
                              <th>DATE DERNIER SOLDE</th>
                              <th>GESITE</th>
                              <th>SOLDE MOMO</th>
                              <th  className="text-center">PRODUIT</th>
                              <th  className="text-center">FDR GESITE</th>
                              <th>FDR COMMERCIAUX</th>
                              <th>FLOAT ENVOYE MARCHANDS</th>
                              <th>FLOAT ENVOYE COMMERCIAUX</th>
                              <th>FLOAT RECU ADV</th>
                              <th>FLOAT RETOURNE ADV</th>
                              <th>FLOAT RETOURNE MARCHAND</th>
                              <th>FLOAT RETOURNE COMMERCIAUX</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr key={index}>
                              <td class="py-1">
                              {row.SecteurCommercial}
                              </td>
                              <td>{row.DateSoldeMomoUpdate != null ? moment(row.DateSoldeMomoUpdate).format('Do MMMM YYYY H:m:s') : ""}</td>
                              <td>
                                {row.Site}
                              </td>
                              <td className="text-center">
                              <b>{separateNumber(row.SoldeMomoGesite)}</b>
                              </td>
                              <td className="text-center">
                              {row.Produit}
                              </td>
                             
                              
                              <td className="text-center">
                                  <b className={row.FondDeRoulementGesite > 100000 ? "text-danger" : "text-success"}>{separateNumber(row.FondDeRoulementGesite)  }</b>
                              </td>        
                              <td className="text-center">
                                  <b className={row.FondDeRoulementCommerciaux > 100000 ? "text-danger" : "text-success"}>{separateNumber(row.FondDeRoulementCommerciaux)  }</b>
                              </td>                      
                              <td className="text-center"><b className={row.FloatEnvoyeAuxMarchands > 100000 ? "text-danger" : "text-success"}>{separateNumber(row.FloatEnvoyeAuxMarchands??0)}</b></td> 
                              <td className="text-center">   <b className={row.FloatEnvoyeCommerciaux > 100000 ? "text-danger" : "text-success"}>{separateNumber(row.FloatEnvoyeCommerciaux??0)}</b></td>
                              <td className="text-center">   <b className={row.FloatRecuDeAdv > 100000 ? "text-danger" : "text-success"}>{separateNumber(row.FloatRecuDeAdv??0)}</b></td>
                              <td className="text-center">   <b className={row.FloatRetourneAdv > 100000 ? "text-danger" : "text-success"}>{separateNumber(row.FloatRetourneAdv??0)}</b></td>
                              <td className="text-center">   <b className={row.FloatRetoursMarchands > 100000 ? "text-danger" : "text-success"}>{separateNumber(row.FloatRetoursMarchands??0)}</b></td>
                              <td className="text-center">   <b className={row.FloatRetourneCommerciaux > 100000 ? "text-danger" : "text-success"}>{separateNumber(row.FloatRetourneCommerciaux??0)}</b></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div> 

                  </>
               )) :   (!loading && <p>Aucun commercial trouvé.</p>)}
                </div>
                </div>
              </div>
            </ContentPage>
        </>
    )
}

export default TransactionSoldeGesitePage;